module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="snippet"><header class="snippet-header"><p class="icon icon-svg icon-labelled '+
((__t=( iconClass ))==null?'':__t)+
'"><span class="snippet-title"> '+
((__t=( alias ))==null?'':__t)+
'</span></p></header></div><dl> ';
 if ( showSerialNumber ) { 
__p+=' <dt>'+
((__t=( i18n.tc("Unit", "Serial number:") ))==null?'':__t)+
'</dt><dd>'+
((__t=( serial ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( unitType ) { 
__p+=' <dt>'+
((__t=( i18n.tc( "Unit", "Device type:" ) ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( unitType ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( showTestResult ) { 
__p+=' <dt>'+
((__t=( i18n.tc("Unit", "Testing:") ))==null?'':__t)+
'</dt> ';
 if ( ! tested ) { 
__p+=' <dd class="error">'+
((__t=( i18n.tc("Unit|Testing", "Incomplete") ))==null?'':__t)+
'</dd> ';
 } else { 
__p+=' <dd class="success">'+
((__t=( i18n.tc("Unit|Testing", "Completed") ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 } 
__p+=' ';
 if ( insuranceCompanyName ) { 
__p+=' <dt>'+
((__t=( i18n.tc("Unit", "Insurance company:") ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( insuranceCompanyName ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( alarmCentralName ) { 
__p+=' <dt>'+
((__t=( i18n.tc("Unit", "Alarm central:") ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( alarmCentralName ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( vehicleName ) { 
__p+=' <dt>'+
((__t=( i18n.tc("Unit", "Vehicle:") ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( vehicleName ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( customerName ) { 
__p+=' <dt>'+
((__t=( i18n.tc("Unit", "Registered to:") ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( customerName ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( subscriptionName ) { 
__p+=' <dt>'+
((__t=( i18n.tc("Unit", "Subscription:") ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( subscriptionName ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( transientInstallerName ) { 
__p+=' <dt>'+
((__t=( i18n.tc("Unit", "Installer:") ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( transientInstallerName ))==null?'':__t)+
'</dd> ';
 } 
__p+=' </dl> ';
 if(showTechnical) { 
__p+=' <h5 class="module-title">'+
((__t=( i18n.tc( "UnitTechnical", "Technical" ) ))==null?'':__t)+
'</h5><dl><dt>'+
((__t=( i18n.tc("Unit", "Device ID:") ))==null?'':__t)+
'</dt><dd>'+
((__t=( id ))==null?'':__t)+
'</dd><dt class="green">'+
((__t=( i18n.tc( "UnitTechnical", "SIM-number:" ) ))==null?'':__t)+
'</dt> ';
 if ( iccid ) { 
__p+=' <dd class="success">'+
((__t=( iccid ))==null?'':__t)+
'</dd> ';
 } else { 
__p+=' <dd class="error">'+
((__t=( i18n.tc( "UnitTechnical", "Not found" ) ))==null?'':__t)+
'</dd> ';
 } 
__p+=' <dt>'+
((__t=( i18n.tc( "UnitTechnical", "IP-address:" ) ))==null?'':__t)+
'</dt> ';
 if ( ipAddress ) { 
__p+=' <dd class="success">'+
((__t=( ipAddress ))==null?'':__t)+
'</dd> ';
 } else { 
__p+=' <dd class="error">'+
((__t=( i18n.tc( "UnitTechnical", "Not found" ) ))==null?'':__t)+
'</dd> ';
 } 
__p+=' <dt>'+
((__t=( i18n.tc( "UnitTechnical", "Active number:" ) ))==null?'':__t)+
'</dt> ';
 if ( activeSim ) { 
__p+=' <dd class="success">'+
((__t=( activeSim ))==null?'':__t)+
'</dd><dt>'+
((__t=( i18n.tc( "UnitTechnical", "Chipsim:" ) ))==null?'':__t)+
'</dt> ';
 if ( isChipSim ) { 
__p+=' <dd class="success">'+
((__t=( i18n.tc( "UnitTechnical", "Yes" ) ))==null?'':__t)+
'</dd> ';
 } else { 
__p+=' <dd class="success">'+
((__t=( i18n.tc( "UnitTechnical", "No" ) ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 } else { 
__p+=' <dd class="error">'+
((__t=( i18n.tc( "UnitTechnical", "Not found" ) ))==null?'':__t)+
'</dd> ';
 } 
__p+=' </dl> ';
 } 
__p+='';
}
return __p;
};
